var map = {
	"./1.m4a": [
		865,
		448
	],
	"./12.m4a": [
		39,
		164
	],
	"./13.m4a": [
		808,
		741
	],
	"./14.m4a": [
		102,
		726
	],
	"./15.m4a": [
		664,
		826
	],
	"./2.m4a": [
		238,
		817
	],
	"./21.m4a": [
		125,
		551
	],
	"./27.m4a": [
		555,
		412
	],
	"./6.m4a": [
		856,
		901
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 456;
module.exports = webpackAsyncContext;